export const ActionTypes={
    SET_PRODUCTS:"SET_PRODUCTS",
    SELECTED_PRODUCT:"SELECTED_PRODUCT",
    INIT_CART:"INIT_CART",
    RESET_CART:"RESET_CART",
    SET_CART:"SET_CART"
}